import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

const ImageText = ({ image, text, className, textClassName }) => (
  <div className={[styles.schoolTitle, styles[className]].join(' ')}>
    <div className={styles.imgPlaceholder}>
      <img src={image} alt={text} />
    </div>
    <span className={styles[textClassName]}>{text}</span>
  </div>
);

ImageText.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  textClassName: PropTypes.string,
};

ImageText.defaultProps = {
  className: null,
  textClassName: '',
};

export default ImageText;
